<section *ngIf="mapInfo?.topics?.sensor || mapInfo?.topics?.location" class="w-full ci-main-padding relative my-6 xl:my-8 flex flex-column xl:flex-row gap-3">
  <section class="w-full xl:w-4">
    <h3 class="ci-txt-body text-xl xl:text-2xl font-bold ci-txt--{{color}}">
      {{mapInfo?.title}}
    </h3>

    <section class="hidden xl:block">
      <p class="ci-txt-body text-lg ci-txt--black-lighten mt-3">
        {{mapInfo?.description}}
      </p>

      <section *ngFor="let item of checkboxItems; let i = index" class="mt-3">
        <label class="flex align-items-center justify-content-between cursor-pointer py-3 fadein animation-duration-500"
          [ngClass]="{'border-gray-300 border-bottom-1': i < checkboxItems?.length-1}">
          <section class="flex align-items-center gap-1 mr-3">
            <section class="w-2rem h-2rem">
              <img class="h-full w-auto" alt="Item Icon" [src]="item?.icon">
            </section>

            <span class="ci-txt--black text-lg">
              {{ item.label }}
            </span>
          </section>

          <input *ngIf="!item.disabled" class="ml-3" type="checkbox" [checked]="item.isChecked"
            [disabled]="item?.disabled" (change)="execCheckboxFunctions(i)">
        </label>
      </section>
    </section>
  </section>

  <section class="w-full xl:w-8 h-30rem">
    <article class="w-full h-full test-map fadein animation-duration-100 relative overflow-hidden border-round-xl">
      <section *ngIf="mapId" [id]="mapId" class="w-full h-full z-3"></section>

      <section
        class="w-fit absolute bottom-0 right-0 mb-2 mr-2 md:mb-3 md:mr-3 z-4 flex flex-column gap-3 fadeinright animation-duration-500">
        <section
          class="w-3rem h-3rem md:w-4rem md:h-4rem cursor-pointer ci-bg--white shadow-4 border-circle flex align-items-center justify-content-center relative"
          (click)="isVisible = !isVisible">
          <i class="bi bi-layers text-2xl md:text-3xl ci-txt--purple cursor-pointer"></i>

          <section *ngIf="checkedItemsLength > 0" class="absolute top-0 right-0 -mt-1 -mr-1">
            <p-badge [value]="checkedItemsLength" />
          </section>
        </section>

        <section *ngIf="_currentLocationMarker"
          class="w-3rem h-3rem md:w-4rem md:h-4rem cursor-pointer ci-bg--white shadow-4 border-circle flex align-items-center justify-content-center"
          (click)="goToCurrentLocation()">
          <i class="bi bi-crosshair text-2xl md:text-3xl ci-txt--black-lighten cursor-pointer"></i>
        </section>
      </section>

      <section *ngIf="isMapHidden" class="w-full h-full absolute top-0 bottom-0 right-0 left-0 p-3 z-4 bg-black-alpha-40 flex justify-content-center align-items-end"
               (click)="hideOverlayMap()">
        <button class="w-fit ci-btn ci-btn--small ci-btn__{{color}}">
          Pulsa para ver
        </button>
      </section>
    </article>

    <ng-template #labelTemplate>
      <h4 class="w-full text-center text-lg mb-1 font-semibold ci-txt--black-lighten">
        Información
      </h4>

      <section *ngFor="let item of checkboxItems; let i = index">
        <label class="flex align-items-center justify-content-between cursor-pointer py-3 fadein animation-duration-500"
          [ngClass]="{'border-gray-300 border-bottom-1': i < checkboxItems?.length-1}">
          <section class="flex align-items-center gap-1 mr-3">
            <section class="w-2rem h-2rem">
              <img class="h-full w-auto" alt="Item Icon" [src]="item?.icon">
            </section>

            <span class="ci-txt--black text-lg">
              {{ item.label }}
            </span>
          </section>

          <input *ngIf="!item.disabled" class="ml-3" type="checkbox" [checked]="item.isChecked"
            [disabled]="item?.disabled" (change)="execCheckboxFunctions(i)">
        </label>
      </section>
    </ng-template>

    <p-dialog [(visible)]="isVisible" [closable]="false" [modal]="true" [dismissableMask]="true" [header]="'.'">
      <section class="w-full sm:w-25rem flex flex-column px-3">
        <ng-container *ngTemplateOutlet="labelTemplate"></ng-container>
      </section>

      <section class="w-fit fixed top-0 right-0">
        <section class="w-1rem h-1rem border-round-3xl flex align-items-center justify-content-center"
          (click)="closeDialog()">
          <i class="bi bi-x-circle-fill text-3xl ci-txt--cherry cursor-pointer"></i>
        </section>
      </section>

      <ng-template pTemplate="footer">
        <section class="w-full p-3">
          <button class="w-full ci-btn ci-btn--small ci-btn__purple" (click)="closeDialog()">
            Cerrar
          </button>
        </section>
      </ng-template>
    </p-dialog>
  </section>
</section>